import { EmailAttachment } from './email-attachment.model';

export class MailParameters {
    userId = -1;
    EmailFrom = '';
    EmailTo = '';
    DisplayEmailToOnComment = '';
    DisplayEmailCcOnComment = '';
    DisplayEmailBccOnComment = '';
    EmailToCc = '';
    EmailToBcc = '';
    Subject = '';
    Body = '';
    AddEmailToParentContactLog = false;
    PeopleIds = '';
    ToMemIds: number[] = [];
    CCMemIds: number[] = [];
    BCCMemIds: number[] = [];
    PersonCode: number;
    Attachments: EmailAttachment[] = [];
    HtmlBody: boolean;
}
